import Confetti from 'react-confetti';
import React, { useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';

type ConfettiOverlayProps = {
  isActive: boolean;
  numberOfPieces?: number;
  recycle?: boolean;
  opacity?: number;
  onComplete?: () => void;
};

const useWindowSize = () => {
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setSize({ width: window.innerWidth, height: window.innerHeight });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return size;
};

export const ConfettiOverlay = ({
  isActive,
  numberOfPieces = 200,
  recycle = false,
  opacity = 0.8,
  onComplete,
}: ConfettiOverlayProps): React.ReactNode => {
  const { width, height } = useWindowSize();

  const handleConfettiComplete = useCallback(() => {
    onComplete?.();
  }, [onComplete]);

  if (!isActive) {
    return null;
  }

  return createPortal(
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 9999,
      }}
    >
      <Confetti
        width={width}
        height={height}
        numberOfPieces={numberOfPieces}
        opacity={opacity}
        recycle={recycle}
        onConfettiComplete={handleConfettiComplete}
      />
    </div>,
    document.body,
  ) as React.ReactNode;
};
